import {createAsyncThunk} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    getDocuments as getDocumentsApi,
    getDownloadDocument as getDownloadDocumentApi,
    getViewPDF as getViewPDFApi,
    extractDocument as extractDocumentApi,
    addDocument as addDocumentApi,
    updateDocument as updateDocumentApi,
    deleteDocument as deleteDocumentApi
} from "../../helpers/fakebackend_helper";


export const getDocuments = createAsyncThunk("documents",
    async (queryParams) => {
        try {
            return await getDocumentsApi(queryParams)
        } catch (error) {
            toast.error("Failed to fetch documents", { autoClose: 3000 });
            throw error;
        }
    })


export const getDownloadDocument = createAsyncThunk("documents",
    async (id) => {
        try {
            return await getDownloadDocumentApi(id)
        } catch (error) {
            toast.error("Failed to fetch documents", { autoClose: 3000 });
            throw error;
        }})


export const getViewPDF = createAsyncThunk("documents",
    async (id) => {
        try {
            return await getViewPDFApi(id)
        } catch (error) {
            toast.error("Failed to fetch pdf", { autoClose: 3000 });
            throw error;
        }})

export const addDocument = createAsyncThunk("documents",
    async (data) => {
        try {
            return await addDocumentApi(data)
        } catch (error) {
            toast.error("Failed to fetch pdf", { autoClose: 3000 });
            throw error;
        }})

export const extractDocument = createAsyncThunk("documents",
    async (data) => {
        try {
            return await extractDocumentApi(data)
        } catch (error) {
            toast.error("Failed to extract pdf", { autoClose: 3000 });
            throw error;
        }})

export const updateDocument = createAsyncThunk("documents",
    async (data) => {
        try {
            return await updateDocumentApi(data)
        } catch (error) {
            toast.error("Failed to update document", { autoClose: 3000 });
            throw error;
        }})

export const deleteDocument = createAsyncThunk("documents",
    async (id) => {
        try {
            return await deleteDocumentApi(id)
        } catch (error) {
            toast.error(`Failed to delete document`, { autoClose: 3000 });
            throw error;
        }})
